import type { Card } from './card';

/** Branded type for player identifiers */
export type PlayerId = string & { readonly __brand: 'PlayerId' };

/** Create a PlayerId from a string (use at creation boundaries) */
export function createPlayerId(id: string): PlayerId {
  return id as PlayerId;
}

export enum Team {
  TEAM_A = 'A', // Players 0 and 2 (across from each other)
  TEAM_B = 'B', // Players 1 and 3 (across from each other)
}

export enum PlayerPosition {
  SOUTH = 0, // Bottom (local player typically)
  WEST = 1,
  NORTH = 2,
  EAST = 3,
}

export interface Player {
  id: PlayerId;
  name: string;
  position: PlayerPosition;
  team: Team;
  isConnected: boolean;
  isAI: boolean;
  hand: Card[];
}

export interface PlayerPublicState {
  id: PlayerId;
  name: string;
  position: PlayerPosition;
  team: Team;
  isConnected: boolean;
  isAI: boolean;
  cardCount: number;
}

export function getTeamForPosition(position: PlayerPosition): Team {
  // Players 0 and 2 are Team A (across from each other)
  // Players 1 and 3 are Team B (across from each other)
  return position % 2 === 0 ? Team.TEAM_A : Team.TEAM_B;
}

export function getPartnerPosition(position: PlayerPosition): PlayerPosition {
  // Partner is 2 positions away (across the table)
  return ((position + 2) % 4) as PlayerPosition;
}

export function getNextPosition(position: PlayerPosition): PlayerPosition {
  // Play goes counterclockwise: SOUTH -> EAST -> NORTH -> WEST -> SOUTH
  // In terms of array indices: 0 -> 3 -> 2 -> 1 -> 0
  const order = [0, 3, 2, 1];
  const currentIndex = order.indexOf(position);
  return order[(currentIndex + 1) % 4] as PlayerPosition;
}

export const POSITION_NAMES: Record<PlayerPosition, string> = {
  [PlayerPosition.SOUTH]: 'South',
  [PlayerPosition.WEST]: 'West',
  [PlayerPosition.NORTH]: 'North',
  [PlayerPosition.EAST]: 'East',
};
